import type { DividerDesignTokens } from '@primeuix/themes/types/divider';

/**
 * Divider component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/divider/index.ts
 *
 * Component documentation:
 * https://primeng.org/divider
 */
export const dividerComponentTokens: Partial<DividerDesignTokens> = {
  root: {
    borderColor: '{border.main}',
  },
};
